/**
 * Logout flow trace hooks. Functions are no-ops for console output; they keep
 * minimal session state so {@link ensureLogoutTrace} / {@link endLogoutTrace}
 * behave correctly. Call sites may be re-instrumented if needed.
 */

let traceStartMs: number | null = null;

/**
 * Starts a new logout trace session (call from /logout route or first AuthContext.logout).
 */
export function startLogoutTrace(): void {
  traceStartMs =
    typeof performance !== "undefined" ? performance.now() : Date.now();
}

/**
 * Ensures a trace exists when logout() is invoked without going through /logout (e.g. API hook).
 */
export function ensureLogoutTrace(): void {
  if (traceStartMs === null) {
    startLogoutTrace();
  }
}

/**
 * Trace phase (no-op).
 */
export function logoutTrace(
  _phase: string,
  _detail?: Record<string, unknown>
): void {}

/**
 * Ends the trace session. Safe to call multiple times.
 */
export function endLogoutTrace(_reason: string): void {
  traceStartMs = null;
}

/**
 * Init-time trace (no-op).
 */
export function logoutInitTrace(
  _phase: string,
  _detail?: Record<string, unknown>
): void {}
